import { render, staticRenderFns } from "./SelectUserTypeComp.vue?vue&type=template&id=40b7568b&scoped=true&"
import script from "./SelectUserTypeComp.vue?vue&type=script&lang=js&"
export * from "./SelectUserTypeComp.vue?vue&type=script&lang=js&"
import style0 from "./SelectUserTypeComp.vue?vue&type=style&index=0&id=40b7568b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b7568b",
  null
  
)

export default component.exports